import type { Maybe } from '@adornis/base/utilTypes.js';

export enum RegisterMode {
  REGISTRATION_ELEMENTARY_ELEMENTARY,
  REGISTRATION_HIGH_HIGH,
  REGISTRATION_ELEMENTARY_HIGH,
  REGISTRATION_NEW_ELEMENTARY,
}

export enum SchoolRegisterOrigin {
  ELEMENTARY_HIGH = 'Übergang von der Grundschule',
  CHANGE_SCHOOL = 'Wechsel der Schule',
}

export function calculateRegisterMode(klasse: Maybe<string>, origin: Maybe<string>) {
  if (klasse === '1') return RegisterMode.REGISTRATION_NEW_ELEMENTARY;
  if (klasse === '5' && origin === SchoolRegisterOrigin.ELEMENTARY_HIGH)
    return RegisterMode.REGISTRATION_ELEMENTARY_HIGH;
  if (klasse && parseInt(klasse) < 5) return RegisterMode.REGISTRATION_ELEMENTARY_ELEMENTARY;
  return RegisterMode.REGISTRATION_HIGH_HIGH;
}
